export const GET_REMINDERS_COUNT = "/admin_requests/reminders/";
export const GET_REMINDERS = "/admin_requests/reminder_details/";
export const GET_REMINDER_DETAILS = "/admin_requests/:memberId/:requestId/";
export const RELEASE_ALL_REMINDER = "/admin_requests/reminders/send/";
